import { ApiResponse } from '@ametista-ai/api-schema/http/types';
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/stores/api/apiClient';

export function useStopImpersonating() {
  return useMutation({
    mutationFn: () =>
      apiClient.post<ApiResponse<{ success: boolean }>>('/v1/auth/stop-impersonating', {}),
  });
}
